const authProvider = {
  login: async ({ username, password }) => {
    // Hardcoded admin credentials
    const ADMIN_USERNAME = "Admin";
    const ADMIN_PASSWORD = "ZulekAdmin$11";

    if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
      // Store only username in localStorage
      localStorage.setItem("username", username);
      return Promise.resolve();
    }
    
    return Promise.reject(new Error("Invalid credentials"));
  },

  logout: () => {
    // Clear only username from localStorage
    localStorage.removeItem("username");
    return Promise.resolve();
  },

  checkAuth: () =>
    localStorage.getItem("username") ? Promise.resolve() : Promise.reject(),

  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("username");
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getIdentity: () =>
    Promise.resolve({
      id: "admin",
      fullName: "Zulek Admin",
    }),

  // Simplified user details (no channel partner info needed)
  getUserDetails: () => ({
    isAdmin: true,
  }),
};

export default authProvider;